import { Container, Row, Col } from "reactstrap";
import { FaEdit } from "react-icons/fa";
import { ImagesAssets } from "../../Component/shared/ImageAssets";
import { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import "./css/OnboardingEdmDetails.css";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import OnboardEDMDetailsModalContent from "./ModalContent/OnboardEDMDetailsModalContent";
import GlobalShimmer from "../../utils/GlobalShimmer";

const OnboardingEdmDetails = ({
  EDMDetailsData,
  EDMDetailsLoading,
  rowData,
}: {
  EDMDetailsData: any;
  EDMDetailsLoading?: boolean;
  rowData?: any;
}) => {
  // console.log(
  //   "🚀 ~ OnboardingEdmDetails.tsx:21 ~ OnboardingEdmDetails ~ rowData:",
  //   rowData?.Orgunitid
  // );

  console.log(
    "🚀 ~ OnboardingEdmDetails.tsx:12 ~ OnboardingEdmDetails ~ EDMDetailsData:",
    EDMDetailsData
  );

  const [isImageOpen, setIsImageOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const toggleImageModal = () => setIsImageOpen(!isImageOpen);
  const toggleEditModal = () => setIsEditOpen(!isEditOpen);
  const handleUpdate = (row: any, status: any) => {
    setIsEditOpen(true);
  };

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const details = [
    {
      label: "Salutation",
      value: EDMDetailsData?.Salutation || "-",
    },
    { label: "Full name", value: EDMDetailsData?.FirstName || "-" },
    // { label: "Last name", value: EDMDetailsData?.LastName || "-" },
    { label: "Outlet name", value: EDMDetailsData?.OutletName || "-" },
    { label: "Email address", value: EDMDetailsData?.Email || "-" },
    { label: "Phone number", value: EDMDetailsData?.Mobile || "-" },
    { label: "Gender", value: EDMDetailsData?.Gender || "-" },
    { label: "Date of birth", value: EDMDetailsData?.DateOfBirth || "-" },
    { label: "Marital Status", value: EDMDetailsData?.MaritalStatus || "-" },
    {
      label: "Date of anniversary",
      value: EDMDetailsData?.DateOfAnniversary || "-",
    },
    { label: "Qualifications", value: EDMDetailsData?.Qualification || "-" },
    {
      label: "Registration number",
      value: EDMDetailsData?.RegistrationNo || "-",
    },

    { label: "Territory", value: EDMDetailsData?.TerritoryName || "-" },
    { label: "Position", value: EDMDetailsData?.PositionName || "-" },
    { label: "Outlet type", value: EDMDetailsData?.OutletTypeName || "-" },
    {
      label: "Language",
      value:
        EDMDetailsData?.LanguageData && EDMDetailsData?.LanguageData?.length > 0
          ? EDMDetailsData?.LanguageData.map(
              (lang: any) => lang?.LanguageName
            ).join(", ")
          : "-",
    },
  ];

  return (
    <>
      <Container fluid className="p-4" style={{ backgroundColor: "#fff" }}>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="fw-bold">EDM Details</h5>
          {!EDMDetailsLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginRight: "15px",
                }}
              >
                <span style={{ marginRight: "5px" }}>Status : </span>
                <span
                  style={{
                    display: "flex",
                    fontWeight: "700",
                    color: "#48AC1C",
                  }}
                >
                  {EDMDetailsData?.Status}
                </span>
              </div>

              <button
                onClick={() => handleUpdate(Row, "Update")}
                className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
                style={{
                  borderRadius: "20px",
                  padding: "3px",
                  width: "70px",
                  backgroundColor:
                    EDMDetailsData?.Status === "Executed" ||
                    EDMDetailsData?.Status === "Final Approved"
                      ? "grey"
                      : "#43bab2",
                  borderColor:
                    EDMDetailsData?.Status === "Executed" ||
                    EDMDetailsData?.Status === "Final Approved"
                      ? "grey"
                      : "#43bab2",
                  color: "#ffffff",
                }}
                disabled={
                  EDMDetailsData?.Status === "Executed" ||
                  EDMDetailsData?.Status === "Final Approved"
                }
              >
                <FaEdit size={14} style={{ fill: "#fff" }} />
                Edit
              </button>
            </div>
          )}
        </div>

        <div className="d-flex">
          {/* Profile Image or Shimmer */}
          <div
            style={{ width: "320px", marginTop: "5px" }}
            onClick={toggleImageModal}
          >
            {EDMDetailsLoading ? (
              <GlobalShimmer width="200px" height="200px" shape="circle" />
            ) : (
              <img
                src={
                  EDMDetailsData?.ProfilePic
                    ? `${BASE_URL}${EDMDetailsData?.ProfilePic}`
                    : "https://via.placeholder.com/100?text=No+Image"
                }
                alt="avatar"
                style={{
                  width: "170px",
                  height: "170px",
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
              />
            )}
          </div>

          <div>
            <Row>
              {EDMDetailsLoading
                ? Array.from({ length: 15 }).map((_, idx) => (
                    <Col md="2" sm="6" xs="12" className="mb-3 mt-3" key={idx}>
                      <GlobalShimmer width="150px" height="20px" />
                    </Col>
                  ))
                : details.map((item, index) => (
                    <Col md="2" sm="6" xs="12" className="mb-3" key={index}>
                      <small className="text-muted">{item.label}</small>
                      <div
                        className="fw-semibold"
                        style={{
                          color:
                            item?.value === "Pharmacy"
                              ? "#43B8B1"
                              : item?.value === "Doctor"
                              ? "#2E8DD3"
                              : "#000",
                          borderRadius: "12px",
                          maxWidth: "100%",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                          fontWeight: "800",
                        }}
                      >
                        {item.value}
                      </div>
                    </Col>
                  ))}
            </Row>
          </div>
        </div>

        <Modal
          isOpen={isImageOpen}
          toggle={toggleImageModal}
          centered
          backdrop={true}
          modalClassName="no-bg-modal"
          className="d-flex justify-content-center align-items-center"
        >
          <ModalBody
            style={{
              position: "relative",
              padding: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
              height: "400px",
            }}
            onClick={toggleImageModal}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{ position: "relative", borderRadius: "50%" }}
            >
              {/* Close button */}
              {/* <Button
              onClick={toggleImageModal}
              style={{
                position: "absolute",
                top: "-40px",
                right: "-90px",
                backgroundColor: "red",
                borderRadius: "50%",
                padding: "6px",
                zIndex: 10,
                color: "#ffffff",
                width: "30px",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              X
            </Button> */}
              {/* Image */}
              <img
                src={
                  EDMDetailsData?.ProfilePic
                    ? `${BASE_URL}${EDMDetailsData?.ProfilePic}`
                    : "https://via.placeholder.com/100?text=No+Image"
                }
                alt="avatar-large"
                className="zoom-in-animation"
                style={{
                  width: "500px",
                  height: "500px",
                  objectFit: "cover",
                  borderRadius: "50%",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
                }}
              />
            </div>
          </ModalBody>
        </Modal>
      </Container>
      <RouteModal
        isOpen={isEditOpen}
        toggle={toggleEditModal}
        title={"Edit EDM Details"}
        size="xl"
        content={
          <OnboardEDMDetailsModalContent
            setIsEditOpen={setIsEditOpen}
            EDMDetailsData={EDMDetailsData}
            rowData={rowData}
            // handleSubmit={handleSubmit}
            // handleClose={handleClose}
            // editLeaveConfigurationModal={editLeaveConfigurationModal}
            // selectedRowData={selectedRowData}
          />
        }
      />
    </>
  );
};

export default OnboardingEdmDetails;
